(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    let lockedScrollY = 0;

    const getDetails = (fromEl) => fromEl && fromEl.closest('details.menu-drawer-container');

    const closeDrawer = (details) => {
      if (!details || !details.open) return;
      const summary = details.querySelector('summary');
      if (summary) summary.click();
    };

    const lockScroll = () => {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('cfon-menu-scroll-lock');
      document.body.style.top = `-${lockedScrollY}px`;
    };

    const unlockScroll = () => {
      if (!document.body.classList.contains('cfon-menu-scroll-lock')) return;
      document.body.classList.remove('cfon-menu-scroll-lock');
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
    };

    document.addEventListener(
      'click',
      (event) => {
        const childrenToggle = event.target.closest('.menu-drawer--cfon .menu-drawer__children-toggle');
        if (childrenToggle) {
          event.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener('click', (event) => {
      const closeBtn = event.target.closest('[data-cfon-drawer-close]');
      if (closeBtn) {
        closeDrawer(getDetails(closeBtn));
        return;
      }

      const overlay = event.target.closest('[data-cfon-drawer-overlay]');
      if (overlay && event.target === overlay) {
        closeDrawer(getDetails(overlay));
      }
    });

    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.classList.contains('menu-drawer-container')) return;
      if (!details.closest('.header--cfon')) return;

      if (details.open) {
        lockScroll();
      } else {
        unlockScroll();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const isDesktopHover = () => window.matchMedia('(hover: hover) and (min-width: 990px)').matches;

    const menuFrom = (node) => {
      if (!node || !node.closest) return null;
      return node.closest('.header--cfon header-menu');
    };

    document.addEventListener('click', (event) => {
      if (!isDesktopHover()) return;
      if (event.detail === 0) return;
      const summary = event.target.closest('.header--cfon header-menu details > summary');
      if (!summary) return;
      event.preventDefault();
    });

    document.addEventListener('mouseover', (event) => {
      if (!isDesktopHover()) return;
      const menu = menuFrom(event.target);
      if (!menu) return;
      if (menuFrom(event.relatedTarget) === menu) return;
      const details = menu.querySelector('details');
      if (details) details.setAttribute('open', '');
    });

    document.addEventListener('mouseout', (event) => {
      if (!isDesktopHover()) return;
      const menu = menuFrom(event.target);
      if (!menu) return;
      if (menuFrom(event.relatedTarget) === menu) return;
      const details = menu.querySelector('details');
      if (details) details.removeAttribute('open');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
